<template>
  <el-select
    ref="select"
    :value="value"
    filterable
    :multiple="multiple"
    :clearable="clearable"
    :placeholder="placeholder"
    class="cargo-owned-branch-select"
    :style="style"
    @input="onInput"
    @change="onChange"
    @visible-change="onVisibleChange"
  >
    <el-tooltip v-for="option in finalOptions" :key="option.uuid" :content="getLabelTip(option)" placement="left">
      <el-option :value="option.officeId" :label="getLabel(option)" />
    </el-tooltip>
  </el-select>
</template>

<script>
// import { getLength } from '@/utils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getCacheListByKey, getFilterCacheList, getObjectByCache } from '@/utils/basicDataCache'
import { sortByMultiField } from '@/utils'

export default {
  name: 'CargoOwnedBranchSelect',
  props: {
    selectType: { type: String, default: TYPE_NAMES.basic_data_Office },
    methodParams: { type: Object, default: () => ({}) },
    staticOptions: { type: Array, default: null },
    value: { type: [Number, Array], required: true },
    multiple: { type: Boolean, default: false }, // 是否多选
    clearable: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    widthAutoFit: { type: Boolean, default: false },
    refreshId: { type: Number, default: 0 }
  },
  data() {
    return {
      settingLabel: '',
      options: [],
      extraOption: null,
      isEdit: false, // 是否正在编辑
      style: '',
      finalOptions: []
    }
  },
  watch: {
    '$store.state.settings.partnerLabelSettings': {
      handler: function() {
        this.readSettingLabel()
        this.init()
      }
    },
    methodParams() {
      this.init()
    },
    staticOptions() {
      this.init()
    },
    value() {
      this.matchCurrentValue()
      this.$nextTick(() => {
        this.onVisibleChange(this.isEdit)
      })
    },
    multiple() {
      this.matchCurrentValue()
      this.$nextTick(() => {
        this.onVisibleChange(this.isEdit)
      })
    },
    refreshId() {
      this.onVisibleChange(this.isEdit)
    }
  },
  created() {
    this.readSettingLabel()
    this.init()
  },
  methods: {
    readSettingLabel() {
      const configs = this.$store.state.settings.partnerLabelSettings
      const curConfig = configs.find(config => config.autoKey === 'auto_office')
      this.settingLabel = Object.keys(curConfig).find(key => typeof curConfig[key] === 'boolean' && curConfig[key])
    },
    init() {
      this.resetOptions()
      this.matchCurrentValue()
      this.$nextTick(() => {
        this.onVisibleChange(this.isEdit)
      })
    },
    resetOptions() {
      if (this.staticOptions) {
        this.options = this.staticOptions
      } else {
        const keys = Object.keys(this.methodParams)
        if (keys.length > 0) {
          this.options = getFilterCacheList(this.selectType, item => {
            for (const key of keys) {
              if (item[key] !== this.methodParams[key]) {
                return false
              }
            }
            return true
          })
        } else {
          this.options = getCacheListByKey(this.selectType)
        }
      }
      this.resetFinalOptions()
    },
    matchCurrentValue() {
      this.extraOption = null
      if (!this.multiple && this.value > 0) {
        let option = this.options.find(item => item.officeId === this.value)
        if (!option) {
          this.extraOption = getObjectByCache(TYPE_NAMES.basic_data_Office_All, 'officeId', this.value)
          option = this.extraOption
        }
      }
      this.resetFinalOptions()
      if (this.widthAutoFit) {
        let text = ''
        let fontSize = 0
        let paddingWidth = 0
        if (this.multiple) {
          text = this.getMultiDisplay()
          fontSize = 12
          paddingWidth = 9
        } else {
          const option = this.finalOptions.find(item => item.officeId === this.value)
          if (option) {
            text = this.getLabel(option)
          }
          fontSize = 12
          paddingWidth = 25
        }
        const textWidth = this.getTextWidth(text, fontSize, paddingWidth)
        this.style = `width: ${textWidth + 15}px`
      }
    },
    getLabel(option) {
      let txt = ''
      switch (this.settingLabel) {
        case 'chineseName':
          txt = option.chineseName
          break
        case 'englishName':
          txt = option.englishName
          break
        default:
          txt = option.code
          break
      }
      return txt
    },
    getLabelTip(option) {
      let tip = ''
      switch (this.settingLabel) {
        case 'chineseName':
          tip = option.code
          break
        case 'englishName':
          tip = option.code
          break
        default:
          tip = this.$getLangColumn(option)
          break
      }
      return tip
    },
    onInput(val) {
      this.$emit('input', val)
    },
    onChange() {
      this.$emit('change')
    },
    onVisibleChange(isEdit) {
      this.isEdit = isEdit
      if (this.multiple) {
        this.convertMultiSelectedToText()
      } else {
        if (isEdit) {
          return
        }
        const option = this.finalOptions.find(p => p.officeId === this.value)
        if (option) {
          this.$nextTick(() => {
            const input = this.$refs.select.$children[0].$el.children[0]
            const tip = this.getLabelTip(option)
            input.value = this.getTextEllipsis(this.getLabel(option), input.offsetWidth)
            input.title = tip
            this.$emit('tipChange', tip)
          })
        } else {
          this.$nextTick(() => {
            const input = this.$refs.select.$children[0].$el.children[0]
            input.value = ''
            input.title = ''
            this.$emit('tipChange', '')
          })
        }
      }
    },
    convertMultiSelectedToText() {
      this.$nextTick(() => {
        const select = this.$refs.select
        const tags = select.$el.querySelector('.el-select__tags')
        if (!tags || !tags.childNodes || tags.childNodes.length === 0) {
          return
        }
        let customDisplay = null
        let input = null
        for (const child of tags.childNodes) {
          if (!child.classList) {
            continue
          }
          if (child.classList.contains('custom-display')) {
            customDisplay = child
          } else if (child.classList.contains('el-select__input')) {
            input = child
          }
        }
        if (!customDisplay) {
          customDisplay = document.createElement('span')
          customDisplay.className = 'custom-display'
          tags.insertBefore(customDisplay, tags.childNodes[0])
        }
        if (this.isEdit) {
          customDisplay.style.display = 'none'
          if (input) {
            input.style.display = ''
            input.value = ''
            input.setAttribute('placeholder', this.getMultiDisplay(input.offsetWidth) || this.placeholder)
            input.focus()
          }
        } else {
          customDisplay.style.display = ''
          customDisplay.innerText = this.getMultiDisplay(customDisplay.offsetWidth)
          customDisplay.setAttribute('title', this.getMultiDisplay())
          if (input) {
            input.style.display = 'none'
          }
        }
      })
    },
    getMultiDisplay(width) {
      const texts = []
      for (const subValue of this.value) {
        const option = this.finalOptions.find(p => p.officeId === subValue)
        if (option) {
          texts.push(this.getLabel(option))
        }
      }
      if (typeof width === 'number') {
        return this.getTextEllipsis(texts.join(','), width, 12, 9)
      }
      return texts.join(',')
    },
    getTextEllipsis(text, width, fontSize = 12, paddingWidth = 25) {
      if (width > 0) {
        const textWidth = this.getTextWidth(text, fontSize, paddingWidth)
        if (textWidth > width) {
          for (let i = 3; i <= text.length; ++i) {
            const subText = text.substring(0, i)
            const subTextWidth = this.getTextWidth(subText, fontSize, paddingWidth)
            if (subTextWidth > width) {
              return text.substring(0, i - 2) + '...'
            }
          }
        }
      }
      return text
    },
    getTextWidth(text, fontSize, paddingWidth) {
      // let w = getLength(text) * 0.5 * fontSize + paddingWidth // 文本字节数 * 0.5 * font-size + paddingWidth
      // for (let i = 0; i < text.length; ++i) {
      //   const c = text.charAt(i)
      //   if (c === 'I') {
      //     w -= 1.8
      //   } else if (c >= 'A' && c <= 'Z') { // 大写字母占用的宽度会比标准大一点
      //     w += 1.8
      //   } else if (c === '（' || c === '）') {
      //     w += 4.2
      //   }
      // }
      // return w
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      ctx.font = `normal ${fontSize}px sans-serif`
      return ctx.measureText(text).width + paddingWidth
    },
    resetFinalOptions() {
      const result = []
      const list = this.extraOption ? [this.extraOption, ...this.options] : [...this.options]
      sortByMultiField(list, ['level'])
      const uuidPathMap = new Map()
      for (const item of list) {
        if (item.parentBranchUuid) {
          const parentPath = uuidPathMap.get(item.parentBranchUuid)
          const path = parentPath + ',' + item.code
          uuidPathMap.set(item.uuid, path)
          item.path = path
          result.push(item)
        } else {
          uuidPathMap.set(item.uuid, item.code)
          item.path = item.code
          result.push(item)
        }
      }
      sortByMultiField(result, ['path'])
      this.finalOptions = result
    }
  }
}
</script>

<style lang="scss" scoped>
.cargo-owned-branch-select::v-deep.el-select {
    .el-select__tags {
      .custom-display {
        width: 100%;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        margin-left: 9px;
      }
      .el-tag--info {
        display: none;
      }
      .el-select__input {
        margin-left: 9px;
        font-size: 12px;
      }
    }
}
</style>
